import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";
import ConsoleLogger from "../Utils/ConsoleLogger";
import Loading from 'react-loading-bar';
import 'react-loading-bar/dist/index.css';
import ReCAPTCHA from "react-google-recaptcha";
import Footer from "./Footer";
import Script from 'react-load-script';
import WebShare from "./WebShare";
import MobileShare from "./MobileShare";

let config = require('../Config/appConfig.json');
let api_credentials_url = config.GET_API_CREDENTIALS;
let URL_SEND_EMAIL = config.SEND_MAIL_URL;
let KEY_SENDING_MAIL = config.KEY_SENDING_MAIL;
const context = "BookingForm.js";
const NOTIFICATION_TYPE_ERROR = "error";
const NOTIFICATION_TYPE_SUCCESS = "success";
let self = null;
var captcha = null;
@inject("appStore")
@observer
class BookingForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isCaptchaverified: false,
            name: "",
            email: "",
            pickUpDate: "",
            phone: "",
            dropDate: "",
            noOfSeaters: 0,
            pickUpPlace: "",
            dropPlace: "",
            pickUpTime: "",
            dropTime: "",
            purpose: "",
            isReturn: false,
            isAc: false,
            refNum: ""
        };
    }

    componentWillMount = () => {
        self = this;


    }

    onNameChange = (event) => {
        this.setState({
            name: event.target.value
        })
    }

    onEmailChange = (event) => {
        this.setState({
            email: event.target.value
        })
    }

    onPickUpDateChange = (event) => {
        this.setState({
            pickUpDate: event.target.value
        })
    }

    onPhoneChange = (event) => {
        this.setState({
            phone: event.target.value
        })
    }

    onRefNumChange = (event) => {
        this.setState({
            refNum: event.target.value
        })
    }

    onDropDateChange = (event) => {
        this.setState({
            dropDate: event.target.value
        })
    }

    onDropTimeChange = (e) => {
        this.setState({
            dropTime: e.target.value
        })
    }

    onPickUpTimeChange = (e) => {
        this.setState({
            pickUpTime: e.target.value
        })
    }

    onSeatCapacityChange = (event) => {
        this.setState({
            noOfSeaters: event.target.value
        })
    }
    setCaptchaRef = (ref) => {
        captcha = ref;
    }
    onReCaptchaChange = (value) => {
        //console.log("ReCaptcha Value => ", value)
        if (value.length > 0) {
            //console.log("Verified")
            this.setState({
                isCaptchaverified: true
            })
        }
    }
    onPurposeChange = (e) => {
        this.setState({
            purpose: e.target.value
        })
    }
    onReturnTripChange = (e) => {
        var prev_isreturn = this.state.isReturn;
        var new_value = !prev_isreturn
        this.setState({
            isReturn: new_value
        })
    }
    onAcChange = (e) => {
        var prev_isac = this.state.isAc;
        var new_value = !prev_isac
        this.setState({
            isAc: new_value
        })
    }

    submitForm = () => {
        console.log("Submit Called");

        var isCaptchaverified = this.state.isCaptchaverified;
        var name = this.state.name;
        var email = this.state.email;
        var pickUpDate = this.state.pickUpDate;
        var phone = this.state.phone;
        var dropDate = this.state.dropDate;
        var seartCapacity = this.state.noOfSeaters;
        var pickUpPlace = this.state.pickUpPlace;
        var dropPlace = this.state.dropPlace;
        var pickUpTime = this.state.pickUpTime;
        var dropTime = this.state.dropTime;
        var purpose = this.state.purpose;
        var isReturn = this.state.isReturn;
        var isAc = this.state.isAc;
        var refNum = this.state.refNum;
        var car_type = "";
        if (isAc) {
            car_type = "AC"
        } else {
            car_type = "Non AC"
        }

        var today = new Date().toLocaleDateString('en-CA');
        var pickupDatetime = pickUpDate + ' ' + pickUpTime;
        var dropDatetime = dropDate + ' ' + dropTime;

        if (isCaptchaverified) {
            /*console.log("Name  => " + name);
            console.log("email  => " + email);
            console.log("pickUpDate  => " + pickUpDate);
            console.log("phone  => " + phone);
            console.log("dropDate  => " + dropDate);
            console.log("Pickup place = > " + pickUpPlace);
            console.log("Drop Place => " + dropPlace);
            console.log("Seat Capacity => " + seartCapacity);
            console.log("pickUpTime  => " + pickUpTime);
            console.log("dropTime  => " + dropTime);
            console.log("picupDate numeric=>" + Date.parse(pickUpDate));
            console.log("dropDate numeric=>" + Date.parse(dropDate));
            console.log("today numeric=>" + Date.parse(today));
            console.log("isReturn=>" + this.state.isReturn);
            console.log("IsAc=>" + this.state.isAc);
            
            console.log("pickuptime numeric=>" + Date.parse(pickupDatetime));
            console.log("droptime numeric=>" + Date.parse(dropDatetime));
            */
            if ((refNum !== undefined) && (refNum !== null) && (refNum !== "") && (refNum.length === 10)) {
                refNum = "+91" + refNum;
            }

            if (name === null || name === "" || name === undefined || name.length < 3) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Name field is invalid");
            } else if (email === null || email === "" || email === undefined || email.length < 6 || email === "email@client.com" || /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) === false) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Email field is invalid");
            } else if (phone == null || phone === "" || phone === undefined || phone.length < 10) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "WhatsApp field is invalid");
            } else if (pickUpDate === null || pickUpDate === "" || pickUpDate === undefined || pickUpDate.length < 3) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "PickUp date is invalid");
            } else if (dropDate === null || dropDate === "" || dropDate === undefined || dropDate.length < 3) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Drop date is invalid");
            } else if ((seartCapacity === undefined || seartCapacity === null || isNaN(seartCapacity) || seartCapacity <= 0)) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Number of seats is invalid");
            } else if (pickUpPlace === undefined || pickUpPlace === null || pickUpPlace === "") {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Pickup Location is invalid");
            } else if (dropPlace === undefined || dropPlace === null || dropPlace === "") {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Drop Location is invalid");
            } else if (pickUpTime === undefined || pickUpTime === null || pickUpTime === "" || pickUpTime.length < 3) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Pickup Time is invalid");
            } else if (dropTime === undefined || dropTime === null || dropTime === "" || dropTime.length < 3) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Drop Time is invalid");
            } else if (purpose === undefined || purpose === null || purpose === "") {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Purpose is invalid");
            } else if (Date.parse(pickupDatetime) >= Date.parse(dropDatetime)) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Pickup should be before Drop ");
            } else if (Date.parse(pickUpDate) < Date.parse(today)) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Pickup date can not be in past");
            } else {

                var subject = "Group ride cab request from : " + name
                var txt = "Name : ".concat(name);
                txt = txt.concat("\n Email Id : ", email);
                txt = txt.concat("\n Phone Number : ", phone);
                txt = txt.concat("\n PickUp Location : ", pickUpPlace);
                txt = txt.concat("\n Pickup Date: ", pickUpDate);
                txt = txt.concat("\n Drop Location : ", dropPlace);
                txt = txt.concat("\n Drop Date: ", dropDate);
                txt = txt.concat("\n Number of seats: ", seartCapacity);
                var email_body = {
                    'name': name,
                    'email': email,
                    'phone': phone,
                    'pickup_location': pickUpPlace,
                    'drop_location': dropPlace,
                    'pickup_time': pickUpTime,
                    'pickup_date': pickUpDate,
                    'car_type': car_type,
                    'num_seat': seartCapacity,
                    'is_return': isReturn,
                    'avg_distance': 0,
                    'avg_duration': 0,
                    'num_days': 0,
                    'purpose': purpose,
                    'return_date': dropDate,
                    'return_time': dropTime,
                    'source': "WEB",
                    'conversation': null,
                    'ref_num': refNum
                }


                // console.log("email_body=", email_body);

                this.sendMail(txt, subject, email_body)
            }

        } else {
            this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Please verify the captcha")
        }
    }

    addNotifiation = (type, message) => {
        window.sendNotification(type, message)
    }

    sendMail = (text, subject, email_body) => {
        var info = {
            secret_key: KEY_SENDING_MAIL,
            subject: subject,
            text: text,
            email_body_db: email_body
        };

        fetch(URL_SEND_EMAIL, {
            method: 'POST',
            //headers: JSON.stringify(headers),
            body: JSON.stringify(info)
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (responseJson) {
                try {
                    var resJson = JSON.stringify(responseJson);
                    // console.log("Success => " + resJson)
                    if (responseJson.status === 200) {
                        self.addNotifiation(NOTIFICATION_TYPE_SUCCESS, "Message sent successfully");
                        document.getElementById("name").value = "";
                        document.getElementById("email").value = "";
                        document.getElementById("phone").value = "";
                        document.getElementById("no_of_seats").value = "";
                        document.getElementById("autocompletePickUpLocation").value = "";
                        document.getElementById("autocompleteDropLocation").value = "";
                        document.getElementById("pickupDate").value = "";
                        document.getElementById("pickupTime").value = "";
                        document.getElementById("dropDate").value = "";
                        document.getElementById("dropTime").value = "";
                        document.getElementById("purpose").value = "";
                        document.getElementById("ref_num").value = "";
                        captcha.reset();
                        self.setState({
                            isCaptchaverified: false,
                            name: "",
                            email: "",
                            pickUpDate: "",
                            phone: "",
                            dropDate: "",
                            noOfSeaters: 0,
                            pickUpPlace: "",
                            dropPlace: "",
                            pickUpTime: "",
                            dropTime: "",
                            purpose: "",
                            refNum: ""
                        })
                    } else {
                        self.addNotifiation(NOTIFICATION_TYPE_ERROR, responseJson.result);
                    }
                } catch (e) {
                    console.log("1 Error => " + e)
                }
            })
            .catch(function (error) {
                console.log("2 Error => " + error)
            });
    }

    componentDidMount = () => {
        //console.log("PROPS", this.props);
        console.log("window.navigator.share=", window.navigator.share);
    }


    handleScriptLoad = () => {
        // Declare Options For Autocomplete
        const options = {
            //   types: ['(cities)'],
            componentRestrictions: { country: 'in' }
        };

        // Initialize Google Autocomplete
        /*global google*/ // To disable any eslint 'google not defined' errors
        this.autocompletePickUpLocation = new google.maps.places.Autocomplete(
            document.getElementById('autocompletePickUpLocation'),
            options,
        );

        this.autocompleteDropLocation = new google.maps.places.Autocomplete(
            document.getElementById('autocompleteDropLocation'),
            options,
        );

        // Avoid paying for data that you don't need by restricting the set of
        // place fields that are returned to just the address components and formatted
        // address.
        this.autocompletePickUpLocation.setFields(['address_components', 'formatted_address']);
        this.autocompleteDropLocation.setFields(['address_components', 'formatted_address']);

        // Fire Event when a suggested name is selected
        this.autocompletePickUpLocation.addListener('place_changed', this.handlePickUpSelect);
        this.autocompleteDropLocation.addListener('place_changed', this.handleDropSelect);
    }

    handlePickUpSelect = () => {

        // Extract City From Address Object
        const addressObject = this.autocompletePickUpLocation.getPlace();
        const address = addressObject.address_components;
        // console.log(addressObject);
        // console.log(address);
        // Check if address is valid
        if (address) {
            // Set State
            this.setState(
                {
                    pickUpPlace: addressObject.formatted_address,
                }
            );
        }
    }

    handleDropSelect = () => {

        // Extract City From Address Object
        const addressObject = this.autocompleteDropLocation.getPlace();
        const address = addressObject.address_components;
        // console.log(addressObject);
        // console.log(address);
        // Check if address is valid
        if (address) {
            // Set State
            this.setState(
                {
                    dropPlace: addressObject.formatted_address,
                }
            );
        }
    }

    generateShareUI = () => {
        var share_ui = "";
        if (window.navigator.share) {
            share_ui = (<MobileShare />);
        } else {
            share_ui = (<WebShare />);
        }
        return share_ui
    }
    render() {
        var share_ui = this.generateShareUI();


        return (
            <div>
                <Script
                    url="https://maps.googleapis.com/maps/api/js?key=AIzaSyBSujUn8M-7Q7i0PJqCjtJDo_zGSTLJ0EY&libraries=places"
                    onLoad={this.handleScriptLoad}
                />
                <section className="pt-120 pb-120" id="booking_form">
                    <div className="container">
                        <div className="row">
                            <div className="col-6">
                                <div className="section-title text-left">
                                    <h3>Got a plan ?</h3>
                                    <h2>You can book it now...</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="contact-form-wrapper">
                                    {/* <h3>Send Us Message</h3> */}
                                    <p>Fill up this form and we will get back to you.</p>
                                    <form method="POST" action="#" className="contact-form">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <input type="text" name="name" id="name" onChange={this.onNameChange} className="theme-input-style" placeholder="Your Name" required /> </div>
                                            <div className="col-md-6">
                                                <input type="email" name="email" id="email" onChange={this.onEmailChange} className="theme-input-style" placeholder="Your Email" required /> </div>
                                            <div className="col-md-6">
                                                <input type="tel" name="phone" id="phone" onChange={this.onPhoneChange} className="theme-input-style" placeholder="WhatsApp number" required /> </div>

                                            <div className="col-md-6">
                                                <input type="number" name="no_of_seats" id="no_of_seats" onChange={this.onSeatCapacityChange} className="theme-input-style" placeholder="Number of seats" required /> </div>
                                            <div className="col-md-6">
                                                <input name="autocompletePickUpLocation" id="autocompletePickUpLocation" className="theme-input-style" placeholder="Choose pickup location" required /> </div>
                                            <div className="col-md-6">
                                                <input name="autocompleteDropLocation" id="autocompleteDropLocation" className="theme-input-style" placeholder="Choose drop location" required /> </div>
                                            <div className="col-md-6">
                                                <label htmlFor="pickupDate">Pickup Date</label>
                                                <input type="date" name="pickupDate" id="pickupDate" className="theme-input-style" onChange={this.onPickUpDateChange} placeholder="Choose pickup date" required /> </div>
                                            <div className="col-md-6">
                                                <label htmlFor="pickupDate">Pickup Time</label>
                                                <input type="time" name="pickupTime" id="pickupTime" className="theme-input-style" onChange={this.onPickUpTimeChange} placeholder="Choose pickup time" required /> </div>
                                            <div className="col-md-6">
                                                <label htmlFor="dropDate">Drop Date</label>
                                                <input type="date" name="dropDate" id="dropDate" className="theme-input-style" onChange={this.onDropDateChange} placeholder="Choose drop date" required /> </div>
                                            <div className="col-md-6">
                                                <label htmlFor="dropTime">Drop Time</label>
                                                <input type="time" name="dropTime" id="dropTime" className="theme-input-style" onChange={this.onDropTimeChange} placeholder="Choose drop time" required /> </div>
                                            <div className="col-md-6">
                                                <label htmlFor="dropTime">Purpose</label>
                                                <select className="theme-input-style" id="purpose" ref="ridePurpose" onChange={this.onPurposeChange}>
                                                    <option value="" disabled selected>-- Select --</option>
                                                    <option value="Wedding" >Wedding</option>
                                                    <option value="Party" >Party</option>
                                                    <option value="Picnic" >Picnic</option>
                                                    <option value="Other" >Other</option>

                                                </select></div>
                                            <div className="col-md-6">
                                                <label htmlFor="dropTime">&nbsp;</label>
                                                <input type="tel" name="ref_num" id="ref_num" onChange={this.onRefNumChange} className="theme-input-style" placeholder="Reference number" /> </div>
                                            <div className="col-md-6">
                                                <div className="row" style={{ paddingTop: '6%' }}>
                                                    <div className="col-md-6">
                                                        <div className="custom-control custom-switch " style={{ width: '100%' }}>
                                                            <label htmlFor="isReturn" style={{ width: '60%' }}>Return trip?</label>
                                                            <input type="checkbox" style={{ position: 'relative' }} onChange={this.onReturnTripChange} className="custom-control-input" id="customSwitch1" />
                                                            <label className="custom-control-label" htmlFor="customSwitch1" ></label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="custom-control custom-switch " style={{ width: '100%' }}>
                                                            <label htmlFor="isAc" style={{ width: '60%' }}>Ac vehicle?</label>
                                                            <input type="checkbox" style={{ position: 'relative' }} onChange={this.onAcChange} className="custom-control-input" id="customSwitch2" />
                                                            <label className="custom-control-label" htmlFor="customSwitch2" ></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <ReCAPTCHA
                                                ref={(r) => this.setCaptchaRef(r)}
                                                style={{ paddingLeft: 13, marginBottom: 20 }}
                                                sitekey="6LfYmFsUAAAAAMwfG0tUZmcXVPoHdOdS4CO1bRx_"
                                                onChange={this.onReCaptchaChange}

                                            />
                                            <div className="col-md-6" onClick={(e) => this.submitForm()}>
                                                <a href="javascript:void(0);" className="btn-get-the-app hover-box-effect">
                                                    <img src="assets/custom_icons/contact/direct.png" className="svg" style={{ 'width': '30px', 'height': '30px', 'marginRight': '20px' }} alt="" /> Request A Booking
                                                    </a>
                                            </div>
                                            <div className="col-md-6">
                                                {share_ui}
                                            </div>

                                        </div>
                                        <div className="form-response"></div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div >
        );
    }
}

export default withRouter(BookingForm);


// WEBPACK FOOTER //
// ./src/Pages/BookingForm.js